import "./StyleSelector.css";
import React from "react";
import Card from "react-bootstrap/Card";
import VerticalList from "../VerticalList.jsx";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import anime from "../../images/animestyle.jpeg";
import vangogh from "../../images/vangoghstyle.jpeg";
import blackwhite from "../../images/blackandwhitestyle.jpeg";
import pastel from "../../images/pastelstyle.jpeg";
import realism from "../../images/photorealisticstyle.jpeg";
import watercolor from "../../images/watercolorstyle.jpeg";

// Style selector panel

// App provides a set list of style suggestions which can be added to the
// user's prompt

class StyleSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentStyle: "Style ***",
    };
  }

  handleStyleCardClick = (title) => {
    this.setState(
      {
        currentStyle: title,
      },
      () => {
        const prompt = document.getElementById("prompt");
        if (this.state.currentStyle !== "Style ***") {
          prompt.value = prompt.value + " " + this.state.currentStyle;
        }
      }
    );
  };

  render() {
    return (
      <Card style={{ height: 600 }}>
        <Card.Header className="light-purple white-text">
          <span>
            Styles
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="tooltip-disabled">
                  If you want your image to be in one of these styles, click on
                  the card!
                </Tooltip>
              }
            >
              <span style={{ marginLeft: "0.5vw" }}>ⓘ</span>
            </OverlayTrigger>
          </span>
        </Card.Header>
        <Card.Body bsPrefix = "selector-panel">
          <VerticalList>
            <StyleCard
              title="Anime"
              imgSrc={anime}
              onClick={this.handleStyleCardClick}
            ></StyleCard>
            <StyleCard
              title="Black and White"
              imgSrc={blackwhite}
              onClick={this.handleStyleCardClick}
            ></StyleCard>
            <StyleCard
              title="Pastel"
              imgSrc={pastel}
              onClick={this.handleStyleCardClick}
            ></StyleCard>
            <StyleCard
              title="Photorealism"
              imgSrc={realism}
              onClick={this.handleStyleCardClick}
            ></StyleCard>
            <StyleCard
              title="Van Gogh"
              imgSrc={vangogh}
              onClick={this.handleStyleCardClick}
            ></StyleCard>
            <StyleCard
              title="Watercolor"
              imgSrc={watercolor}
              onClick={this.handleStyleCardClick}
            ></StyleCard>
          </VerticalList>
        </Card.Body>
      </Card>
    );
  }
}

// Functional component
function StyleCard(props) {
  return (
    <div>
      <Card className = "style-card"
        as="button"
        id={props.title.replace(/\s/g, "")}
        onClick={() => props.onClick(props.title)}
      >
        <Card.Img variant="top" src={props.imgSrc}></Card.Img>
        <Card.Title>{props.title}</Card.Title>
      </Card>
    </div>
  );
}

export default StyleSelector;

//<Button variant="warning" onClick={() => props.onClick(props.title)}>Use Style</Button>